import React, { ComponentPropsWithRef } from 'react'
// import Cover from '../assets/f__valuefit.webp'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import type { TypographyVariant } from '../types/mui'
import { MTypo } from '../components/MTypo/MTypo'
import { isMobilePortrait } from '../utils'

interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}
/**
 * Intro screen
 * Screen 4, 'Introduction' Happiness
 * second presentation screen and is optional
 * FIXME duplicated Branding.tsx
 * @param p
 * @returns
 */
export const Intro = (p: Props) => {
    const { className, titleV, bodyV, ...rest } = p
    const commons = useCommonCtx()
    const {
        state: { params },
    } = commons
    const { brandParams } = params
    const t = useTranslation(commons)
    const brandImgSrc = isMobilePortrait()
        ? brandParams['brandImageUrlMobile']
        : brandParams['brandImageUrl']

    return (
        <div className="flex flex-1 flex-col justify-around items-center">
            <MTypo variant={titleV} className="text-center">
                {t('intro_title')}
            </MTypo>
            <div className={'border-0 border-black border-solid p-2 mt-4 mb-6'}>
                <img
                    className={`w-full pointer-events-none`}
                    src={brandImgSrc}
                />
            </div>
            <MTypo 
                variant={bodyV} 
                outerClassName='p-4'
                textClassName="text-center italic">
                {t('intro_body')}
            </MTypo>
        </div>
    )
}
